import React from "react";

export const IconOption3 = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.618652 10.9523L4.42818 17.6189H12.0472L15.8567 10.9523L13.4758 4.76179L8.2377 0.476074L2.9996 4.76179L0.618652 10.9523Z"
        fill="#F2F2F2"
      />
      <path
        d="M8.23779 0.476074V6.19036"
        stroke="#1E1F23"
        strokeWidth="0.761905"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.0476 17.6189L9.19043 11.9046M13.4761 4.76172L10.1428 7.14267"
        stroke="#1E1F23"
        strokeWidth="0.761905"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 4.76172L6.33333 7.14267M7.28571 11.9046L4.42857 17.6189"
        stroke="#1E1F23"
        strokeWidth="0.761905"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.618652 10.9524L6.33294 10M15.8567 10.9524L10.1425 10"
        stroke="#1E1F23"
        strokeWidth="0.761905"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.1425 8.09519C10.1425 7.04322 9.28974 6.19043 8.23777 6.19043C7.1858 6.19043 6.33301 7.04322 6.33301 8.09519V9.99995C6.33301 11.0519 7.1858 11.9047 8.23777 11.9047C9.28974 11.9047 10.1425 11.0519 10.1425 9.99995V8.09519Z"
        stroke="#1E1F23"
        strokeWidth="0.761905"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
